import { EntityService } from './EntityService';
import { IAccountReg } from '../types';
import axios from 'axios';

export class AccountRegService extends EntityService<IAccountReg> {
    public readonly parentEntities = [];
    protected childrenEntities = [];

    constructor() {
        super(`/AccountReg`);
    }

    public async save(model: IAccountReg): Promise<IAccountReg> {
        const response = await this.axiosPost(`${this.entityUrl}/Save`, model);
        return response.data;
    }

    public async getById(id: number): Promise<IAccountReg> {
        return this.readAll(`GetById?id=${id}`).then((data: IAccountReg[]) => data[0]);
    }

    public async verifyEmail(id: number, code: string): Promise<boolean> {
        const response = await this.axiosPost(`${this.entityUrl}/VerifyEmail`, {
            id,
            code
        });

        return response.data;
    }

    public async getByEmail(email: string, excludeId: number): Promise<IAccountReg[]> {
        const response = await this.axiosGet(
            `${this.entityUrl}/GetByEmail?email=${encodeURIComponent(email)}&excludeId=${excludeId}`
        );
        return response.data;
    }
}